import { DistributorApiDTO, ImxUserData, UserRole } from '../roles/types';

export enum RoleAssignmentStatus {
  NONE,
  IN_PROGRESS,
  ERROR,
  DONE,
}

export type UserStatus = {
  userName: string;
  isEnabled: boolean;
};

export type User = {
  userEmail: string;
  globalId?: string;
  isSKF?: boolean;
} & UserStatus;

export type ExtendedUser = {
  userRoles: string[];
  roleAssignmentStatus?: RoleAssignmentStatus;
} & User;

export type ResponseMessage = {
  Title: string;
  Status: number;
};

export const getEmptyUser = (): User => ({
  isEnabled: true,
  userName: '',
  userEmail: '',
  isSKF: false,
  globalId: '',
});

export type UsersRolesInformation = {
  users: ExtendedUser[];
  usersRoles: UserRole[];
};

export type SingleUsersRolesInformation = {
  user: ExtendedUser;
  usersRoles: UserRole[];
};

export type UserRolesInformationDTO = {
  user: string;
  userRoles: UserRoleInformative[];
  imxUserData?: ImxUserData;
  distributors?: DistributorApiDTO[];
};

export type UserRoleInformative = {
  companyId: string;
  companyName: string;
  industryCode: number;
  industryName: string;
  industryOrder: number;
  industryText: string;
  plantUnit: string;
  portalCode: string;
  portalName: string;
  roleId: string;
  roleName: string;
  siteCountryCode: string;
  siteCountryDescription: string;
};

export interface UserAccess {
  userPortalAccess: UserAccessPortal[];
  loading: boolean;
}
export interface UserAccessPortal {
  webPortalName: string;
  webPortalUrl: string;
  webPortalIcon: string;
}

export interface UserIdentityInfo {
  userName: string;
  userEmail: string;
  isSKF: boolean;
  pendingToBeAdded: boolean;
}

export interface UserIdentityInfoWithStatus {
  user?: UserIdentityInfo;
  status: number;
}
